import { useEffect, useState, useRef } from "react";
import { Loader } from "lucide-react";
import serverURL from "../../config/serverConfig"

const AUTOSAVE_INTERVAL = 30000;

const Notepad = (props) => {

    const [noteData, setNoteData] = useState();
    const [noteInfo, setNoteInfo] = useState();
    const [savedNote, setSavedNote] = useState();
    const [autoSaving, setAutoSaving] = useState(false);

    // refs so the autosave interval always sees current values without re-registering
    const noteDataRef = useRef(noteData);
    const savedNoteRef = useRef(savedNote);
    useEffect(() => { noteDataRef.current = noteData; }, [noteData]);
    useEffect(() => { savedNoteRef.current = savedNote; }, [savedNote]);

    useEffect(() => {
        fetch(serverURL + "getNotes", {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ project_id: props.projectID }),
        })
            .then(response => response.json())
            .then((jsonData) => {
                setNoteData(jsonData[0].detail)
                setSavedNote(jsonData[0].detail)
                setNoteInfo(jsonData[0])
            })
            .catch((error) => { console.log(error) })
    }, [])

    const saveNote = (contents) => {
        setSavedNote(contents);
        return fetch(serverURL + "updateNote", {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ detail: contents, project_id: props.projectID }),
        })
            .then(r => r.json())
            .catch((error) => { console.log(error) });
    }

    const updateNote = () => saveNote(noteData);

    // autosave every 30s — only if there are unsaved changes
    useEffect(() => {
        if (!noteInfo) return;
        const interval = setInterval(async () => {
            if (noteDataRef.current !== savedNoteRef.current) {
                setAutoSaving(true);
                await Promise.all([
                    saveNote(noteDataRef.current),
                    new Promise(res => setTimeout(res, 1500)),
                ]);
                setAutoSaving(false);
            }
        }, AUTOSAVE_INTERVAL);
        return () => clearInterval(interval);
    }, [noteInfo]);

    return (
        <div id="notepad">
            <h5 className="blockHeader">Notepad</h5>
            {noteInfo ?
                <div id="noteText">
                    <textarea name="noteData" className="text-xs p-2"
                        placeholder="Write your notes here..."
                        value={noteData ? noteData : ""}
                        onChange={e => setNoteData(e.target.value)}
                        rows={10}
                    />
                    <div className="flex justify-end items-center gap-2">
                        {autoSaving && (
                            <span className="flex items-center gap-1 text-[10px] text-[#888]">
                                <Loader size={11} className="spinning"/> saving
                            </span>
                        )}
                        <button disabled={noteData === savedNote} onClick={updateNote}>SAVE</button>
                    </div>
                </div>
            :
                <Loader className="spinning"/>
            }
        </div>
    )
}

export default Notepad;